import React from 'react';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import styles from './loader.css';
import { getIsLoadingWithId } from '../../reducers/project-state';
import Tips from '../../lib/default-project/titles.json';
const returnRandomText = () => {
  const userName = localStorage.getItem('tw:username') || '创作者';

  const titles = Tips;

  if (!titles || titles.length === 0) {
    return '你好世界';
  }

  const randomTitle = titles[Math.floor(Math.random() * titles.length)];
  return randomTitle.replace('${UserName}', userName);
};
const mainMessages = {
  'gui.loader.headline': (
    <FormattedMessage defaultMessage="Loading Project" description="Main loading message" id="gui.loader.headline" />
  ),
  'gui.loader.creating': (
    <FormattedMessage defaultMessage="Creating Project" description="Main creating message" id="gui.loader.creating" />
  )
};

const messages = defineMessages({
  projectData: {
    defaultMessage: 'Loading project …',
    description: 'Appears when loading project data, but not assets yet',
    id: 'tw.loader.projectData'
  },
  downloadingAssets: {
    defaultMessage: 'Downloading assets ({complete}/{total}) …',
    description: 'Appears when loading project assets from a project on a remote website',
    id: 'tw.loader.downloadingAssets'
  },
  loadingAssets: {
    defaultMessage: 'Loading assets ({complete}/{total}) …',
    description: "Appears when loading project assets from a project file on the user's computer",
    id: 'tw.loader.loadingAssets'
  }
});

// Because progress events are fired so often during the very performance-critical loading
// process and React updates are very slow, we bypass React for updating the progress bar.

class LoaderComponent extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this, ['handleAssetProgress', 'handleProjectLoaded', 'barInnerRef', 'messageRef']);
    this.barInnerEl = null;
    this.messageEl = null;
    this.ignoreProgress = false;
  }
  componentDidMount() {
    this.handleAssetProgress(this.props.vm.runtime.finishedAssetRequests, this.props.vm.runtime.totalAssetRequests);
    this.props.vm.on('ASSET_PROGRESS', this.handleAssetProgress);
    this.props.vm.runtime.on('PROJECT_LOADED', this.handleProjectLoaded);
  }
  componentWillUnmount() {
    this.props.vm.off('ASSET_PROGRESS', this.handleAssetProgress);
    this.props.vm.runtime.off('PROJECT_LOADED', this.handleProjectLoaded);
  }
  handleAssetProgress(finished, total) {
    if (this.ignoreProgress || !this.barInnerEl || !this.messageEl) {
      return;
    }

    if (total === 0) {
      // Started loading a new project.
      this.barInnerEl.style.width = '0';
      this.messageEl.textContent = this.props.intl.formatMessage(messages.projectData);
    } else {
      this.barInnerEl.style.width = `${(finished / total) * 100}%`;
      const message = this.props.isRemote ? messages.downloadingAssets : messages.loadingAssets;
      this.messageEl.textContent = this.props.intl.formatMessage(message, {
        complete: finished,
        total
      });
    }
  }
  handleProjectLoaded() {
    if (this.ignoreProgress || !this.barInnerEl || !this.messageEl) {
      return;
    }

    this.ignoreProgress = true;
    this.props.vm.runtime.resetProgress();
  }
  barInnerRef(barInner) {
    this.barInnerEl = barInner;
  }
  messageRef(message) {
    this.messageEl = message;
  }

  render() {
    const circle1Id = styles.circle_1 || styles.circle1 || 'circle_1';
    const circle2Id = styles.circle_2 || styles.circle2 || 'circle_2';
    const circle3Id = styles.circle_3 || styles.circle3 || 'circle_3';
    return (
      <div
        className={classNames(
          styles.background,
          {
            [styles.fullscreen]: this.props.isFullScreen
          },
          {
            [styles.fadeOut]: this.props.isExiting
          },
          this.props.className
        )}
      >
        <div className={styles.container}>
          <div className={styles.logoLoader}>
            <div className={styles.circle} id={circle1Id} />
            <div className={styles.circle} id={circle2Id} />
            <div className={styles.circle} id={circle3Id} />
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            <div className={styles.title}>
              {mainMessages[this.props.messageId]}
              {!(!this.props.projectTitle && this.props.projectTitle == '') && (
                <span>:"{this.props.projectTitle}"</span>
              )}
            </div>
            <div className={styles.message} ref={this.messageRef} />

            <div className={styles.barOuter}>
              <div className={styles.barInner} ref={this.barInnerRef} />
            </div>
            <div className={styles.Tips}>{returnRandomText()}</div>
          </div>
        </div>
      </div>
    );
  }
}

LoaderComponent.propTypes = {
  intl: intlShape,
  isExiting: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isRemote: PropTypes.bool,
  messageId: PropTypes.string,
  className: PropTypes.string,
  vm: PropTypes.shape({
    on: PropTypes.func,
    off: PropTypes.func,
    runtime: PropTypes.shape({
      totalAssetRequests: PropTypes.number,
      finishedAssetRequests: PropTypes.number,
      resetProgress: PropTypes.func,
      on: PropTypes.func,
      off: PropTypes.func
    })
  })
};
LoaderComponent.defaultProps = {
  isExiting: false,
  isFullScreen: false,
  messageId: 'gui.loader.headline'
};

const mapStateToProps = (state) => ({
  isRemote: getIsLoadingWithId(state.scratchGui.projectState.loadingState),
  loadingState: state.scratchGui.projectState.loadingState,
  vm: state.scratchGui.vm,
  projectTitle: state.scratchGui.projectTitle
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LoaderComponent));
